import { queryClient } from '@/queryClient'

export const AUTH_STORAGE_KEYS = [
    'loggedIn',
    'user',
    'orgAccount',
    'org',
    'accounts',
    'businessAccounts',
    'activeBusiness',
]

export const clearStoredAuthState = () => {
    AUTH_STORAGE_KEYS.forEach(key => localStorage.removeItem(key))
}

export const invalidateBrowserAuthState = () => {
    clearStoredAuthState()
    queryClient.clear()
}

export const isAuthEndpoint = (url?: string): boolean => !!url && url.includes('/me')

export const isPublicAuthException = (url?: string): boolean => {
    if (!url) return false

    return (
        url.includes('/portal/') ||
        url.includes('/public/interview/') ||
        url.includes('/auth/magic-link') ||
        url.includes('/freebie/')
    )
}
